import React from 'react'
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Form,
  Input,
  Label,
  Row,
  Col,
} from 'reactstrap'

interface BusinessInformationProps {
  name: string
  email: string
  website: string
  telephone: string
  statementDescriptor: string
  nameError?: string
  emailError?: string
  websiteError?: string
  telephoneError?: string
  statementDescriptorError?: string
  onFieldChange: (field: string, value: string) => void
  disabled?: boolean
}

const BusinessInformation: React.FC<BusinessInformationProps> = ({
  name,
  email,
  website,
  telephone,
  statementDescriptor,
  nameError,
  emailError,
  websiteError,
  telephoneError,
  statementDescriptorError,
  onFieldChange,
  disabled = false,
}) => {
  return (
    <Card className="mb-4">
      <CardHeader>
        <CardTitle className="h5 mb-0">Business Information</CardTitle>
      </CardHeader>
      <CardBody>
        <Form>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label
                  className="form-label fw-bold text-decoration-underline"
                  htmlFor="merchant-name"
                >
                  Business Name <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  id="merchant-name"
                  value={name}
                  onChange={(e) => onFieldChange('name', e.target.value)}
                  disabled={disabled}
                  placeholder="Enter business name"
                  invalid={!!nameError}
                  className="border-info"
                />
                {nameError && (
                  <div className="invalid-feedback d-block">{nameError}</div>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="merchant-email">
                  Email Address <span className="text-danger">*</span>
                </Label>
                <Input
                  type="email"
                  id="merchant-email"
                  value={email}
                  onChange={(e) => onFieldChange('email', e.target.value)}
                  disabled={disabled}
                  placeholder="Enter email address"
                  invalid={!!emailError}
                />
                {emailError && (
                  <div className="invalid-feedback d-block">{emailError}</div>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label
                  className="form-label fw-bold text-decoration-underline"
                  htmlFor="merchant-website"
                >
                  Website <span className="text-danger">*</span>
                </Label>
                <Input
                  type="url"
                  id="merchant-website"
                  value={website}
                  onChange={(e) => onFieldChange('website', e.target.value)}
                  disabled={disabled}
                  placeholder="https://example.com"
                  invalid={!!websiteError}
                  className="border-info"
                />
                {websiteError && (
                  <div className="invalid-feedback d-block">{websiteError}</div>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="merchant-telephone">
                  Telephone
                </Label>
                <Input
                  type="tel"
                  id="merchant-telephone"
                  value={telephone}
                  onChange={(e) => onFieldChange('telephone', e.target.value)}
                  disabled={disabled}
                  placeholder="+1234567890"
                  invalid={!!telephoneError}
                />
                {telephoneError && (
                  <div className="invalid-feedback d-block">
                    {telephoneError}
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="mb-3">
                <Label
                  className="form-label"
                  htmlFor="merchant-statement-descriptor"
                >
                  Statement Descriptor
                </Label>
                <Input
                  type="text"
                  id="merchant-statement-descriptor"
                  value={statementDescriptor}
                  onChange={(e) =>
                    onFieldChange('statementDescriptor', e.target.value)
                  }
                  disabled={disabled}
                  placeholder="Enter statement descriptor (appears on customer's bank statement)"
                  maxLength={22}
                  invalid={!!statementDescriptorError}
                />
                {statementDescriptorError && (
                  <div className="invalid-feedback d-block">
                    {statementDescriptorError}
                  </div>
                )}
                <div className="form-text text-muted">
                  This text will appear on the merchant's customers' bank
                  statements. Must be 5-22 characters, contain at least one
                  letter, and use only allowed punctuation: . , : ; ! ? - _ & (
                  ) /
                </div>
              </div>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  )
}

export default BusinessInformation
